
import {cs} from "@Common/react/chain-services";
import * as React from "react";
// import "./";

export const NoColorSvg = ({size}) => (
    <svg viewBox={[0,0,size,size].join(" ")} width={size} height={size} style={{background: "white"}}>
        <line
            x1={0}
            y1={size}
            x2={size}
            y2={0}
            strokeWidth={2}
            stroke="#F33A3A"
        />
    </svg>
);
